import * as i0 from '@angular/core';
import { Component, Injectable, NgModule, NO_ERRORS_SCHEMA, EventEmitter, Directive, ElementRef, Renderer2, HostListener, Input, Output, ErrorHandler, Injector, Inject, InjectionToken } from '@angular/core';
import { CommonModule } from '@angular/common';
import { trigger, state, style, transition, animate, keyframes } from '@angular/animations';
import * as i1 from 'ngx-toastr';
import { Toast, ToastrService, ToastPackage } from 'ngx-toastr';
import { Type, LocaleService } from '@wke/ucc-angular-alt-common';
import { IconModule } from '@wke/ucc-icons';
import { NgwkButtonStyle } from '@wke/ucc-angular-alt-buttons';
import { ModalService } from '@wke/ucc-angular-alt-modal';
import { OverlayModule as OverlayModule$1, Overlay } from '@angular/cdk/overlay';
import { ComponentPortal, PortalInjector } from '@angular/cdk/portal';

/**
 * @ignore
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'ngx-toastr';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@wke/ucc-icons';
import * as ɵngcc4 from '@wke/ucc-angular-alt-modal';
import * as ɵngcc5 from '@wke/ucc-angular-alt-common';
import * as ɵngcc6 from '@angular/cdk/overlay';

const _c0 = ["ngwk-toast", ""];
function ToastCardComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelement(1, "ucc-icon", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("key", ctx_r0.toastOptions.icon);
} }
function ToastCardComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r1.toastOptions.titleClass);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r1.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.title, " ");
} }
function ToastCardComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 12);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r2.toastOptions.messageClass);
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r2.message, ɵngcc0.ɵɵsanitizeHtml);
} }
function ToastCardComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r3.toastOptions.messageClass);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r3.message);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.message, " ");
} }
function ToastCardComponent_div_9_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 17);
    ɵngcc0.ɵɵlistener("click", function ToastCardComponent_div_9_button_3_Template_button_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r9); const button_r7 = restoredCtx.$implicit; const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.onClick(button_r7); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const button_r7 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(button_r7.content);
} }
function ToastCardComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "div", 14);
    ɵngcc0.ɵɵelementStart(2, "div", 15);
    ɵngcc0.ɵɵtemplate(3, ToastCardComponent_div_9_button_3_Template, 2, 1, "button", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.toastOptions.buttons);
} }
function ToastCardComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "div", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleProp("width", ctx_r5.width + "%");
} }
class ToastCardComponent extends Toast {
    // constructor is only necessary when not using AoT
    constructor(toastrService, toastPackage) {
        super(toastrService, toastPackage);
        this.toastrService = toastrService;
        this.toastPackage = toastPackage;
    }
    onClick(button) {
        if (button.onClick && Type.isFunction(button.onClick)) {
            button.onClick();
        }
    }
    hasButtons(buttons) {
        return buttons && buttons.length > 0;
    }
    get toastOptions() {
        return this.options;
    }
}
ToastCardComponent.ɵfac = function ToastCardComponent_Factory(t) { return new (t || ToastCardComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ToastrService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ToastPackage)); };
ToastCardComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ToastCardComponent, selectors: [["", "ngwk-toast", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], attrs: _c0, decls: 11, vars: 7, consts: [[1, "verticalLayout"], [1, "rowAuto", "horizontalLayout"], [1, "rowAuto", "colAvailable"], [1, "horizontalLayout"], ["class", "colAuto toastIconZone", 4, "ngIf"], [1, "colAvailable", "toastContentZone"], [3, "class", 4, "ngIf"], ["role", "alert", "aria-live", "polite", 3, "class", "innerHTML", 4, "ngIf"], ["role", "alert", "aria-live", "polite", 3, "class", 4, "ngIf"], [4, "ngIf"], [1, "colAuto", "toastIconZone"], [3, "key"], ["role", "alert", "aria-live", "polite", 3, "innerHTML"], ["role", "alert", "aria-live", "polite"], [1, "colAuto", "toastSeparator"], [1, "colAuto", "horizontalLayout", "toastButtonZone"], ["class", "buttonPrimary", 3, "click", 4, "ngFor", "ngForOf"], [1, "buttonPrimary", 3, "click"], [1, "toast-progress"]], template: function ToastCardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵtemplate(4, ToastCardComponent_div_4_Template, 2, 1, "div", 4);
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵtemplate(6, ToastCardComponent_div_6_Template, 2, 4, "div", 6);
        ɵngcc0.ɵɵtemplate(7, ToastCardComponent_div_7_Template, 1, 3, "div", 7);
        ɵngcc0.ɵɵtemplate(8, ToastCardComponent_div_8_Template, 2, 4, "div", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, ToastCardComponent_div_9_Template, 4, 1, "div", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(10, ToastCardComponent_div_10_Template, 2, 2, "div", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("@flyInOut", undefined);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.toastOptions.icon);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.message && ctx.toastOptions.enableHtml);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.message && !ctx.toastOptions.enableHtml);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasButtons(ctx.toastOptions.buttons));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.toastOptions.progressBar);
    } }, directives: [ɵngcc2.NgIf, ɵngcc3.IconComponent, ɵngcc2.NgForOf], styles: [".ngx-toastr[_nghost-%COMP%]{padding:0!important;font-family:\"FiraSans Regular\"}.toast-success[_nghost-%COMP%]{background-color:#fff;border:none;box-shadow:0 0 15px 5px #0000001a!important;background-image:none;animation-duration:.7s;animation-name:fadeInToast}.toast-success[_nghost-%COMP%]:hover{box-shadow:0 0 15px 5px #0003!important}.toast-success[_nghost-%COMP%]   .toast-title[_ngcontent-%COMP%]{color:#7ac143;font-size:13px;font-family:\"FiraSans Regular\"!important}.toast-success[_nghost-%COMP%]   .toast-message[_ngcontent-%COMP%]{color:#373737;font-size:11px;margin-top:5px}.toast-success[_nghost-%COMP%]   ucc-icon[_ngcontent-%COMP%]{height:35px;width:35px;font-size:20px;background-color:#7ac143;color:#fff;display:flex;align-items:center;justify-content:center}.toast-warning[_nghost-%COMP%]{background-color:#fff;border:none;box-shadow:0 0 15px 5px #0000001a!important;background-image:none;animation-duration:.7s;animation-name:fadeInToast}.toast-warning[_nghost-%COMP%]:hover{box-shadow:0 0 15px 5px #0003!important}.toast-warning[_nghost-%COMP%]   .toast-title[_ngcontent-%COMP%]{color:#f8694d;font-size:13px;font-family:\"FiraSans Regular\"!important}.toast-warning[_nghost-%COMP%]   .toast-message[_ngcontent-%COMP%]{color:#373737;font-size:11px;margin-top:5px}.toast-warning[_nghost-%COMP%]   ucc-icon[_ngcontent-%COMP%]{height:35px;width:35px;background-color:#f8694d;color:#fff;font-size:20px;display:flex;align-items:center;justify-content:center}.toast-info[_nghost-%COMP%]{background-color:#fff;border:none;box-shadow:0 0 15px 5px #0000001a!important;background-image:none;animation-duration:.7s;animation-name:fadeInToast}.toast-info[_nghost-%COMP%]:hover{box-shadow:0 0 15px 5px #0003!important}.toast-info[_nghost-%COMP%]   .toast-title[_ngcontent-%COMP%]{color:#0081c6;font-size:13px;font-family:\"FiraSans Regular\"!important}.toast-info[_nghost-%COMP%]   .toast-message[_ngcontent-%COMP%]{color:#373737;font-size:11px;margin-top:5px}.toast-info[_nghost-%COMP%]   ucc-icon[_ngcontent-%COMP%]{height:35px;width:35px;background-color:#0081c6;color:#fff;font-size:20px;display:flex;align-items:center;justify-content:center}.toast-error[_nghost-%COMP%]{background-image:none;animation-duration:.7s;animation-name:fadeInToast;box-shadow:0 0 15px 5px #0000001a!important;background-color:#f8694d;color:#fff}.toast-error[_nghost-%COMP%]:hover{box-shadow:0 0 15px 5px #0003!important}.toast-error[_nghost-%COMP%]   .toastSeparator[_ngcontent-%COMP%]{border-bottom:1px solid white}.toast-error[_nghost-%COMP%]   .toastButtonZone[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{background-color:#ce533b}.toast-error[_nghost-%COMP%]   .toast-title[_ngcontent-%COMP%]{font-size:13px;font-family:\"FiraSans Regular\"!important;color:#fff;margin-left:20px}.toast-error[_nghost-%COMP%]   .toast-message[_ngcontent-%COMP%]{font-size:11px;margin-top:5px;margin-left:20px}.toast-error[_nghost-%COMP%]   ucc-icon[_ngcontent-%COMP%]{height:35px;width:35px;background-color:#ce533b;color:#fff;font-size:20px;display:flex;align-items:center;justify-content:center}[_nghost-%COMP%]     .toastIconZone{padding:16px 0 16px 15px!important}[_nghost-%COMP%]     .toastContentZone{padding:16px 16px 16px 10px!important;width:240px}[_nghost-%COMP%]     .toastSeparator{border-bottom:1px solid #373737;margin-bottom:5px}[_nghost-%COMP%]     .toastButtonZone{padding:0 30px 5px 10px;display:flex;align-items:center;justify-content:center;justify-content:flex-end}[_nghost-%COMP%]     .toastButtonZone button{margin-left:5px;position:relative;margin-top:5px;background-color:#0081c6;right:-25px!important}[_nghost-%COMP%]     .toastButtonZone button:hover{background-color:none!important;filter:brightness(120%)}"], data: { animation: [
            trigger('flyInOut', [
                state('inactive', style({
                    opacity: 0
                })),
                transition('inactive => active', animate('300ms ease-in', keyframes([
                    style({
                        opacity: 0
                    }),
                    style({
                        opacity: 1
                    }),
                ]))),
                transition('active => removed', animate('300ms ease-out', keyframes([
                    style({
                        opacity: 1
                    }),
                    style({
                        opacity: 0
                    }),
                ]))),
                state('removed', style({
                    opacity: 0
                }))
            ]),
        ] } });
/** @nocollapse */
ToastCardComponent.ctorParameters = () => [
    { type: ToastrService },
    { type: ToastPackage }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToastCardComponent, [{
        type: Component,
        args: [{
                selector: '[ngwk-toast]',
                template: "<div class=\"verticalLayout\" [@flyInOut]>\r\n  <div class=\"rowAuto horizontalLayout\">\r\n\r\n    <div class=\"rowAuto colAvailable\">\r\n      <div class=\"horizontalLayout\">\r\n          <div *ngIf=\"toastOptions.icon\" class=\"colAuto toastIconZone\">\r\n              <ucc-icon [key]='toastOptions.icon'></ucc-icon>\r\n            </div>\r\n        <div class=\"colAvailable toastContentZone\">\r\n          <div *ngIf=\"title\" [class]=\"toastOptions.titleClass\" [attr.aria-label]=\"title\">\r\n            {{ title }}\r\n          </div>\r\n          <div *ngIf=\"message && toastOptions.enableHtml\" role=\"alert\" aria-live=\"polite\" [class]=\"toastOptions.messageClass\" [innerHTML]=\"message\">\r\n          </div>\r\n          <div *ngIf=\"message && !toastOptions.enableHtml\" role=\"alert\" aria-live=\"polite\" [class]=\"toastOptions.messageClass\" [attr.aria-label]=\"message\">\r\n            {{ message }}\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div *ngIf=\"hasButtons(toastOptions.buttons)\">\r\n        <div class=\"colAuto toastSeparator\"></div>\r\n        <div class=\"colAuto horizontalLayout toastButtonZone\">\r\n          <button *ngFor=\"let button of toastOptions.buttons\" class='buttonPrimary' (click)=\"onClick(button)\">{{button.content}}</button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div *ngIf=\"toastOptions.progressBar\">\r\n      <div class=\"toast-progress\" [style.width]=\"width + '%'\"></div>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
                animations: [
                    trigger('flyInOut', [
                        state('inactive', style({
                            opacity: 0
                        })),
                        transition('inactive => active', animate('300ms ease-in', keyframes([
                            style({
                                opacity: 0
                            }),
                            style({
                                opacity: 1
                            }),
                        ]))),
                        transition('active => removed', animate('300ms ease-out', keyframes([
                            style({
                                opacity: 1
                            }),
                            style({
                                opacity: 0
                            }),
                        ]))),
                        state('removed', style({
                            opacity: 0
                        }))
                    ]),
                ],
                preserveWhitespaces: false,
                styles: [":host.ngx-toastr{padding:0!important;font-family:\"FiraSans Regular\"}:host.toast-success{background-color:#fff;border:none;box-shadow:0 0 15px 5px #0000001a!important;background-image:none;animation-duration:.7s;animation-name:fadeInToast}:host.toast-success:hover{box-shadow:0 0 15px 5px #0003!important}:host.toast-success .toast-title{color:#7ac143;font-size:13px;font-family:\"FiraSans Regular\"!important}:host.toast-success .toast-message{color:#373737;font-size:11px;margin-top:5px}:host.toast-success ucc-icon{height:35px;width:35px;font-size:20px;background-color:#7ac143;color:#fff;display:flex;align-items:center;justify-content:center}:host.toast-warning{background-color:#fff;border:none;box-shadow:0 0 15px 5px #0000001a!important;background-image:none;animation-duration:.7s;animation-name:fadeInToast}:host.toast-warning:hover{box-shadow:0 0 15px 5px #0003!important}:host.toast-warning .toast-title{color:#f8694d;font-size:13px;font-family:\"FiraSans Regular\"!important}:host.toast-warning .toast-message{color:#373737;font-size:11px;margin-top:5px}:host.toast-warning ucc-icon{height:35px;width:35px;background-color:#f8694d;color:#fff;font-size:20px;display:flex;align-items:center;justify-content:center}:host.toast-info{background-color:#fff;border:none;box-shadow:0 0 15px 5px #0000001a!important;background-image:none;animation-duration:.7s;animation-name:fadeInToast}:host.toast-info:hover{box-shadow:0 0 15px 5px #0003!important}:host.toast-info .toast-title{color:#0081c6;font-size:13px;font-family:\"FiraSans Regular\"!important}:host.toast-info .toast-message{color:#373737;font-size:11px;margin-top:5px}:host.toast-info ucc-icon{height:35px;width:35px;background-color:#0081c6;color:#fff;font-size:20px;display:flex;align-items:center;justify-content:center}:host.toast-error{background-image:none;animation-duration:.7s;animation-name:fadeInToast;box-shadow:0 0 15px 5px #0000001a!important;background-color:#f8694d;color:#fff}:host.toast-error:hover{box-shadow:0 0 15px 5px #0003!important}:host.toast-error .toastSeparator{border-bottom:1px solid white}:host.toast-error .toastButtonZone button{background-color:#ce533b}:host.toast-error .toast-title{font-size:13px;font-family:\"FiraSans Regular\"!important;color:#fff;margin-left:20px}:host.toast-error .toast-message{font-size:11px;margin-top:5px;margin-left:20px}:host.toast-error ucc-icon{height:35px;width:35px;background-color:#ce533b;color:#fff;font-size:20px;display:flex;align-items:center;justify-content:center}:host ::ng-deep .toastIconZone{padding:16px 0 16px 15px!important}:host ::ng-deep .toastContentZone{padding:16px 16px 16px 10px!important;width:240px}:host ::ng-deep .toastSeparator{border-bottom:1px solid #373737;margin-bottom:5px}:host ::ng-deep .toastButtonZone{padding:0 30px 5px 10px;display:flex;align-items:center;justify-content:center;justify-content:flex-end}:host ::ng-deep .toastButtonZone button{margin-left:5px;position:relative;margin-top:5px;background-color:#0081c6;right:-25px!important}:host ::ng-deep .toastButtonZone button:hover{background-color:none!important;filter:brightness(120%)}\n"]
            }]
    }], function () { return [{ type: ɵngcc1.ToastrService }, { type: ɵngcc1.ToastPackage }]; }, null); })();

/**
 * Clase que representa la referencia a un Toast. Ver más [ToastService]{@link ToastService}
 */
class NgwkToastRef {
    /** @ignore */
    constructor(_toast = null) {
        this._toast = _toast;
    }
    /**
     * Permite cerrar el toast.
     */
    close() {
        this._toast.toastRef.close();
    }
}

/** Servicio que gestiona todo lo relacionado con los toast la aplicación. Actualmente los tipos que hay son de tipo 'success' (éxito),
 *  'warning' (advertencia), 'info' (informativa) y 'error' (error o problema)
 */
class ToastService {
    /** @ignore */
    constructor(_toastService) {
        this._toastService = _toastService;
        this._toastService.toastrConfig.positionClass = 'toast-bottom-right';
    }
    /**
     * Método que retorna un toast de tipo 'success' (éxito). A parte del título y contenido, se le pueden pasar unas opciones de tipo
     * [INgwkToastOptions]{@link INgwkToastOptions}. Tiene unas opciones predeterminadas que son las [SUCCESS_DEFAULT_OPTIONS]{@link SUCCESS_DEFAULT_OPTIONS}.
     * Retorna la [NgwkToastRef]{@link NgwkToastRef} de la toast
     *
     * @param title Título del toast
     * @param content Contenido del toast
     * @param options Opciones del toast
     */
    success(title = null, content = null, options = null) {
        let activeToast = this._toastService.success(content, title, this.getIndivualConfigOptions(SUCCESS_DEFAULT_OPTIONS, options));
        return new NgwkToastRef(activeToast);
    }
    /**
     * Método que retorna un toast de tipo 'warning' (advertencia). A parte del título y contenido, se le pueden pasar unas opciones de tipo
     * [INgwkToastOptions]{@link INgwkToastOptions}. Tiene unas opciones predeterminadas que son las [WARNING_DEFAULT_OPTIONS]{@link WARNING_DEFAULT_OPTIONS}.
     * Retorna la [NgwkToastRef]{@link NgwkToastRef} de la toast
     *
     * @param title Título del toast
     * @param content Contenido del toast
     * @param options Opciones del toast
     */
    warning(title = null, content = null, options = null) {
        let activeToast = this._toastService.warning(content, title, this.getIndivualConfigOptions(WARNING_DEFAULT_OPTIONS, options));
        return new NgwkToastRef(activeToast);
    }
    /**
     * Método que retorna un toast de tipo 'info' (informativa). A parte del título y contenido, se le pueden pasar unas opciones de tipo
     * [INgwkToastOptions]{@link INgwkToastOptions}. Tiene unas opciones predeterminadas que son las [INFO_DEFAULT_OPTIONS]{@link INFO_DEFAULT_OPTIONS}.
     * Retorna la [NgwkToastRef]{@link NgwkToastRef} de la toast
     *
     * @param title Título del toast
     * @param content Contenido del toast
     * @param options Opciones del toast
     */
    info(title = null, content = null, options = null) {
        let activeToast = this._toastService.info(content, title, this.getIndivualConfigOptions(INFO_DEFAULT_OPTIONS, options));
        return new NgwkToastRef(activeToast);
    }
    /**
     * Método que retorna un toast de error 'info' (error o problema). A parte del título y contenido, se le pueden pasar unas opciones de tipo
     * [INgwkToastOptions]{@link INgwkToastOptions}. Tiene unas opciones predeterminadas que son las [ERROR_DEFAULT_OPTIONS]{@link ERROR_DEFAULT_OPTIONS}.
     * Retorna la [NgwkToastRef]{@link NgwkToastRef} de la toast
     *
     * @param title Título del toast
     * @param content Contenido del toast
     * @param options Opciones del toast
     */
    error(title = null, content = null, options = null) {
        let toastRef = null;
        if (!options || (!options.canClose && !options.buttons)) {
            let button = [{ content: 'Ok', onClick: () => toastRef.close() }];
            options = { buttons: button };
        }
        let activeToast = this._toastService.error(content, title, this.getIndivualConfigOptions(ERROR_DEFAULT_OPTIONS, options));
        toastRef = new NgwkToastRef(activeToast);
        return toastRef;
    }
    /** Método que permite cerrar una toast a través de la referencia de ésta */
    close(toast) {
        toast.close();
    }
    /** Método que permite cerrar todas las toast */
    closeAll() {
        this._toastService.clear();
    }
    getIndivualConfigOptions(defaultOptions, options) {
        let mergedOptions = Object.assign(Object.assign({}, defaultOptions), options);
        let buttonsIndividualConfig = {
            closeButton: mergedOptions.canClose,
            tapToDismiss: mergedOptions.canClose,
            disableTimeOut: !mergedOptions.canClose,
            timeOut: mergedOptions.timeVisible,
            buttons: mergedOptions.buttons,
            icon: mergedOptions.icon
        };
        return buttonsIndividualConfig;
    }
}
ToastService.ɵfac = function ToastService_Factory(t) { return new (t || ToastService)(ɵngcc0.ɵɵinject(ɵngcc1.ToastrService)); };
/** @nocollapse */ ToastService.ɵprov = i0.ɵɵdefineInjectable({ factory: function ToastService_Factory() { return new ToastService(i0.ɵɵinject(i1.ToastrService)); }, token: ToastService, providedIn: "root" });
/** @nocollapse */
ToastService.ctorParameters = () => [
    { type: ToastrService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToastService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.ToastrService }]; }, null); })();
/** Total de tiempo visible de la toast */
const TIME_VISIBLE = 5000;
/** Opciones predeterminadas de la toast de tipo 'success' */
const SUCCESS_DEFAULT_OPTIONS = {
    icon: 'checkIcon',
    canClose: true,
    timeVisible: TIME_VISIBLE,
    buttons: null
};
/** Opciones predeterminadas de la toast de tipo 'warning' */
const WARNING_DEFAULT_OPTIONS = {
    icon: 'exclamation',
    canClose: true,
    timeVisible: TIME_VISIBLE,
    buttons: null
};
/** Opciones predeterminadas de la toast de tipo 'info' */
const INFO_DEFAULT_OPTIONS = {
    icon: 'info',
    canClose: true,
    timeVisible: TIME_VISIBLE,
    buttons: null
};
/** Opciones predeterminadas de la toast de tipo 'error' */
const ERROR_DEFAULT_OPTIONS = {
    icon: null,
    canClose: false,
    timeVisible: TIME_VISIBLE,
    buttons: null
};

;
class ToastModule {
}
ToastModule.ɵfac = function ToastModule_Factory(t) { return new (t || ToastModule)(); };
ToastModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ToastModule });
ToastModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [ToastService], imports: [[
            IconModule,
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToastModule, [{
        type: NgModule,
        args: [{
                declarations: [ToastCardComponent],
                entryComponents: [ToastCardComponent],
                imports: [
                    IconModule,
                    CommonModule
                ], exports: [
                    ToastCardComponent
                ],
                providers: [ToastService],
                schemas: [NO_ERRORS_SCHEMA]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ToastModule, { declarations: function () { return [ToastCardComponent]; }, imports: function () { return [IconModule,
        CommonModule]; }, exports: function () { return [ToastCardComponent]; } }); })();

/**
 * Este servicio tiene como objetivo gestionar las alertas que se utilicen en la aplicación
 */
class AlertService {
    /**@ignore */
    constructor(_modalService, _localeService) {
        this._modalService = _modalService;
        this._localeService = _localeService;
        this._alertWarningRef = null;
        this._alertErrorRef = null;
        this._alertInfoRef = null;
        this._alertQuestionRef = null;
    }
    /**
      * Permite invocar un alert de tipo warning
      *
      * @param content Contenido del alert
      * @param title Título del alert
      * @param buttons Parámetro opcional que permite definir botones al alert sustituyendo a los predeterminados.
      *                      De manera predeterminada únicamente contiene un botón 'Aceptar'
      * @return
      */
    showWarning(content, title = null, buttons, data) {
        this._alertWarningRef = this._modalService.show(content, title, this.getWarningOptions(buttons, data));
        return this._alertWarningRef;
    }
    /**
      * Permite invocar un alert de tipo error
      *
      * @param content Contenido del alert
      * @param title Título del alert
      * @param buttons Parámetro opcional que permite definir botones al alert sustituyendo a los predeterminados
      *                      De manera predeterminada únicamente contiene un botón 'Aceptar'
      * @return
      */
    showError(content, title = null, buttons, data) {
        this._alertErrorRef = this._modalService.show(content, title, this.getErrorOptions(buttons, data));
        return this._alertErrorRef;
    }
    /**
      * Permite invocar un alert de tipo informativo
      *
      * @param content Contenido del alert
      * @param title Título del alert
      * @param buttons Parámetro opcional que permite definir botones al alert sustituyendo a los predeterminados
      *                      De manera predeterminada únicamente contiene un botón 'Aceptar'
      * @return
      */
    showInfo(content, title = null, buttons, data) {
        this._alertInfoRef = this._modalService.show(content, title, this.getInfoOptions(buttons, data));
        return this._alertInfoRef;
    }
    /**
      * Permite invocar un alert de tipo pregunta
      *
      * @param content Contenido del alert
      * @param title Título del alert
      * @param buttons Parámetro opcional que permite definir botones al alert sustituyendo a los predeterminados
      *                      De manera predeterminada contiene unos botones 'Aceptar' y 'Cancelar'
      * @return
      */
    showQuestion(content, title = null, buttons, data) {
        this._alertQuestionRef = this._modalService.show(content, title, this.getQuestionOptions(buttons, data));
        return this._alertQuestionRef;
    }
    getWarningOptions(customButtons, data) {
        if (!customButtons) {
            let btnOk = {
                id: 'modalBtnOk',
                content: this._localeService.getLocaleString('accept'),
                style: NgwkButtonStyle.Primary,
                onClick: () => this._alertWarningRef.close(true)
            };
            customButtons = [btnOk];
        }
        return { buttons: customButtons, windowClass: 'warningAlert', canClose: false, data: data };
    }
    getErrorOptions(customButtons, data) {
        if (!customButtons) {
            let btnOk = {
                id: 'modalBtnOk',
                content: this._localeService.getLocaleString('accept'),
                style: NgwkButtonStyle.Primary,
                onClick: () => this._alertErrorRef.close(true)
            };
            customButtons = [btnOk];
        }
        return { buttons: customButtons, windowClass: 'errorAlert', canClose: false, data: data };
    }
    getInfoOptions(customButtons, data) {
        if (!customButtons) {
            let btnOk = {
                id: 'modalBtnOk',
                content: this._localeService.getLocaleString('accept'),
                style: NgwkButtonStyle.Primary,
                onClick: () => this._alertInfoRef.close(true)
            };
            customButtons = [btnOk];
        }
        return { buttons: customButtons, windowClass: 'infoAlert', canClose: false, data: data };
    }
    getQuestionOptions(customButtons, data) {
        if (!customButtons) {
            let btnAccept = {
                id: 'modalBtnAccept',
                content: this._localeService.getLocaleString('accept'),
                style: NgwkButtonStyle.Primary,
                onClick: () => this._alertQuestionRef.close(true)
            };
            let btnCancel = {
                id: 'modalBtnCancel',
                content: this._localeService.getLocaleString('cancel'),
                style: NgwkButtonStyle.Secondary,
                onClick: () => this._alertQuestionRef.dismiss(false)
            };
            customButtons = [btnCancel, btnAccept];
        }
        return { buttons: customButtons, windowClass: 'questionAlert', canClose: false, data: data };
    }
}
AlertService.ɵfac = function AlertService_Factory(t) { return new (t || AlertService)(ɵngcc0.ɵɵinject(ɵngcc4.ModalService), ɵngcc0.ɵɵinject(ɵngcc5.LocaleService)); };
AlertService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AlertService, factory: AlertService.ɵfac });
/** @nocollapse */
AlertService.ctorParameters = () => [
    { type: ModalService },
    { type: LocaleService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AlertService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc4.ModalService }, { type: ɵngcc5.LocaleService }]; }, null); })();

class AlertModule {
}
AlertModule.ɵfac = function AlertModule_Factory(t) { return new (t || AlertModule)(); };
AlertModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AlertModule });
AlertModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [AlertService], imports: [[
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AlertModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                providers: [AlertService],
                schemas: [NO_ERRORS_SCHEMA]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AlertModule, { imports: function () { return [CommonModule]; } }); })();

/**
 * Esta directiva es utilizada para convertir la zona que engloba ésta en un Sticky Header. Se puede definir el container a partir
 * del cual tomará referencia para convertirse en un Sticky Header y también un Output que detecta cuando se convierte en Sticky
 * Header y vuelve a un estado normal
 *
 * @example
 * <div #scrollContainer>
 * 		<div ngwkStickyHeader
 * 		[ngwkStickyHeaderScrollContainer]="scrollContainer"
 * 		(stickyChanged)="onStickyChanged($event)">
 * 			Content
 * 		</div>
 * </div>
 *
 */
class NgwkStickyHeaderDirective {
    /** @ignore */
    constructor(_el, _renderer) {
        this._el = _el;
        this._renderer = _renderer;
        this._isSticky = false;
        this._stickyPosition = 0;
        this._scrollContainer = null;
        this._isAlive = true;
        this._stickyBlankSpace = null;
        this._stickyChanged = new EventEmitter();
    }
    /** @ignore */
    ngOnInit() {
        this._stickyBlankSpace = this._renderer.createElement('div');
        this._renderer.listen(this.scrollOwner, 'scroll', (event) => {
            this.setStickyHeader(event.srcElement.scrollTop);
        });
    }
    /** @ignore */
    ngOnDestroy() {
        this._isAlive = false;
    }
    setStickyHeader(scrollOffsetY) {
        if (this._isAlive) {
            if (!this._isSticky) {
                this._stickyPosition = this._el.nativeElement.offsetTop;
            }
            if (!this._isSticky && scrollOffsetY > this._stickyPosition) {
                this._isSticky = true;
                this.stickyChanged.emit(this.isSticky);
                this._renderer.setStyle(this._stickyBlankSpace, 'padding-top', `${this._el.nativeElement.clientHeight}px`);
                this._renderer.insertBefore(this._renderer.parentNode(this._el.nativeElement), this._stickyBlankSpace, this._el.nativeElement);
                this._renderer.addClass(this._el.nativeElement, 'sticky');
                if (this.ngwkStickyHeaderScrollContainer) {
                    this._renderer.addClass(this._el.nativeElement, 'sticky--absolute');
                }
                else {
                    this._renderer.addClass(this._el.nativeElement, 'sticky--fixed');
                    this._renderer.setStyle(this._el.nativeElement, 'top', `${this.scrollOwner.getBoundingClientRect().top}px`);
                }
                this.setStickyHeaderWidth();
            }
            else if (this._isSticky && scrollOffsetY <= this._stickyPosition) {
                this._isSticky = false;
                this.stickyChanged.emit(this.isSticky);
                this._renderer.removeChild(this._el.nativeElement, this._stickyBlankSpace);
                this._renderer.removeClass(this._el.nativeElement, 'sticky');
                this._renderer.removeClass(this._el.nativeElement, 'sticky--fixed');
                this._renderer.removeClass(this._el.nativeElement, 'sticky--absolute');
                this._renderer.removeStyle(this._el.nativeElement, 'width');
                this._renderer.removeStyle(this._el.nativeElement, 'top');
            }
        }
    }
    /** @ignore */
    setStickyHeaderWidth() {
        if (this._isSticky) {
            this._renderer.setStyle(this._el.nativeElement, 'width', `${this.scrollOwner.scrollWidth}px`);
        }
    }
    /**
     * Permite obtener el container del Sticky Header si este está definido
     */
    get ngwkStickyHeaderScrollContainer() {
        return this._scrollContainer;
    }
    /**
     * Permite definir el container del Sticky Header
     *
     * @param value El container del Sticky Header
     */
    set ngwkStickyHeaderScrollContainer(value) {
        this._scrollContainer = value;
    }
    /** @ignore */
    get scrollOwner() {
        return this.ngwkStickyHeaderScrollContainer ? this.ngwkStickyHeaderScrollContainer : this._el.nativeElement.parentNode;
    }
    /**
     * Permite consultar si el sticky header está en estado sticky o no
     */
    get isSticky() {
        return this._isSticky;
    }
    /**
     * Emite un evento cuando el Sticky Header pasa a ser sticky y viceversa
     */
    get stickyChanged() {
        return this._stickyChanged;
    }
}
NgwkStickyHeaderDirective.ɵfac = function NgwkStickyHeaderDirective_Factory(t) { return new (t || NgwkStickyHeaderDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
NgwkStickyHeaderDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgwkStickyHeaderDirective, selectors: [["", "ngwkStickyHeader", ""]], hostBindings: function NgwkStickyHeaderDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function NgwkStickyHeaderDirective_resize_HostBindingHandler() { return ctx.setStickyHeaderWidth(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { ngwkStickyHeaderScrollContainer: "ngwkStickyHeaderScrollContainer" }, outputs: { stickyChanged: "stickyChanged" } });
/** @nocollapse */
NgwkStickyHeaderDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
NgwkStickyHeaderDirective.propDecorators = {
    setStickyHeaderWidth: [{ type: HostListener, args: ['window:resize',] }],
    ngwkStickyHeaderScrollContainer: [{ type: Input }],
    stickyChanged: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgwkStickyHeaderDirective, [{
        type: Directive,
        args: [{
                selector: '[ngwkStickyHeader]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { 
    /** @ignore */
    setStickyHeaderWidth: [{
            type: HostListener,
            args: ['window:resize']
        }], ngwkStickyHeaderScrollContainer: [{
            type: Input
        }], stickyChanged: [{
            type: Output
        }] }); })();

class StickyHeaderModule {
}
StickyHeaderModule.ɵfac = function StickyHeaderModule_Factory(t) { return new (t || StickyHeaderModule)(); };
StickyHeaderModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: StickyHeaderModule });
StickyHeaderModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StickyHeaderModule, [{
        type: NgModule,
        args: [{
                exports: [NgwkStickyHeaderDirective],
                declarations: [NgwkStickyHeaderDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(StickyHeaderModule, { declarations: [NgwkStickyHeaderDirective], exports: [NgwkStickyHeaderDirective] }); })();

/**
 * Servicio que sirve exclusivamente para la gestión de los errores de la aplicación, informando al usuario de éstos a través
 * de toast
 */
class ToastErrorHandlerService extends ErrorHandler {
    /** @ignore */
    constructor(injector) {
        super();
        this.injector = injector;
    }
    // Need to get ToastrService from injector rather than constructor injection to avoid cyclic dependency error
    get toastrService() {
        return this.injector.get(ToastService);
    }
    /**
     * Método que se encarga del error que se pase por parámetro, haciendo que se invoque un toast de tipo 'error' informativo para
     * el usuario y que éste pueda gestionar la información recibida como lo vea conveniente
     *
     * @param error Error que se mostrará en el toast informativo de tipo 'error'
     */
    handleError(error) {
        if (error) {
            let errorToast;
            let buttons = [
                { content: "Ok", onClick: () => errorToast.close() }
            ];
            let config = {
                canClose: false,
                buttons: buttons
            };
            errorToast = this.toastrService.error(error.message, error.stack, config);
        }
        super.handleError(error);
    }
}
ToastErrorHandlerService.ɵfac = function ToastErrorHandlerService_Factory(t) { return new (t || ToastErrorHandlerService)(ɵngcc0.ɵɵinject(Injector)); };
ToastErrorHandlerService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ToastErrorHandlerService, factory: ToastErrorHandlerService.ɵfac });
/** @nocollapse */
ToastErrorHandlerService.ctorParameters = () => [
    { type: Injector, decorators: [{ type: Inject, args: [Injector,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToastErrorHandlerService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.Injector, decorators: [{
                type: Inject,
                args: [Injector]
            }] }]; }, null); })();

class ToastErrorHandlerModule {
}
ToastErrorHandlerModule.ɵfac = function ToastErrorHandlerModule_Factory(t) { return new (t || ToastErrorHandlerModule)(); };
ToastErrorHandlerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ToastErrorHandlerModule });
ToastErrorHandlerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        {
            provide: ErrorHandler,
            useClass: ToastErrorHandlerService
        }
    ], imports: [[
            IconModule,
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToastErrorHandlerModule, [{
        type: NgModule,
        args: [{
                imports: [
                    IconModule,
                    CommonModule
                ],
                providers: [
                    {
                        provide: ErrorHandler,
                        useClass: ToastErrorHandlerService
                    }
                ],
                schemas: [NO_ERRORS_SCHEMA]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ToastErrorHandlerModule, { imports: function () { return [IconModule,
        CommonModule]; } }); })();

/**
 * Este componente se utiliza para la declaración de un componente completamente vacio
 *
 * @example
 * <ngwk-blank></ngwk-blank>
 *
 */
class BlankComponent {
    /** @ignore */
    constructor() { }
}
BlankComponent.ɵfac = function BlankComponent_Factory(t) { return new (t || BlankComponent)(); };
BlankComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BlankComponent, selectors: [["ngwk-blank"]], decls: 0, vars: 0, template: function BlankComponent_Template(rf, ctx) { }, encapsulation: 2 });
/** @nocollapse */
BlankComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BlankComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-blank',
                template: ""
            }]
    }], function () { return []; }, null); })();

class BlankModule {
}
BlankModule.ɵfac = function BlankModule_Factory(t) { return new (t || BlankModule)(); };
BlankModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: BlankModule });
BlankModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BlankModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    BlankComponent
                ],
                exports: [
                    BlankComponent
                ],
                entryComponents: [BlankComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BlankModule, { declarations: function () { return [BlankComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [BlankComponent]; } }); })();

class OverlayModule {
}
OverlayModule.ɵfac = function OverlayModule_Factory(t) { return new (t || OverlayModule)(); };
OverlayModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: OverlayModule });
OverlayModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            ToastModule,
            AlertModule,
            StickyHeaderModule,
            ToastErrorHandlerModule,
            BlankModule,
            OverlayModule$1
        ], ToastModule, AlertModule, StickyHeaderModule, ToastErrorHandlerModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OverlayModule, [{
        type: NgModule,
        args: [{
                imports: [
                    ToastModule,
                    AlertModule,
                    StickyHeaderModule,
                    ToastErrorHandlerModule,
                    BlankModule,
                    OverlayModule$1
                ],
                exports: [
                    ToastModule,
                    AlertModule,
                    StickyHeaderModule,
                    ToastErrorHandlerModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(OverlayModule, { imports: function () { return [ToastModule, AlertModule, StickyHeaderModule, ToastErrorHandlerModule, BlankModule, OverlayModule$1]; }, exports: function () { return [ToastModule, AlertModule, StickyHeaderModule, ToastErrorHandlerModule]; } }); })();

/**
 * Clase que representa la referencia a un BlockUI. Ver más: [BlockUIService]{@link BlockUIService}.
 */
class NgwkBlockUIRef {
    /** @ignore */
    constructor(_blockUIRef) {
        this._blockUIRef = _blockUIRef;
    }
    /** Cierra la capa BlockUI */
    close() {
        return this._blockUIRef.dispose();
    }
}

//https://blog.thoughtram.io/angular/2017/11/20/custom-overlays-with-angulars-cdk.html
/**
 * Servicio utilizado para la gestión de BlockUIs, los cuales son un componente que cubren toda la pantalla, bloqueandola
 */
class BlockUIService {
    /** @ignore */
    constructor(_overlay, _injector) {
        this._overlay = _overlay;
        this._injector = _injector;
        this.DEFAULT_OVERLAYCONFIG = {
            hasBackdrop: true,
            scrollStrategy: this._overlay.scrollStrategies.block(),
            positionStrategy: this._overlay
                .position()
                .global()
                .centerHorizontally()
                .centerVertically()
        };
    }
    /**
     * Método que invoca un BlockUI a través de un componente pasado por el parámetro 'component' y una configuración de
     * tipo [NgwkBlockUIConfig]{@link NgwkBlockUIConfig} opcional. Al finalizar este método retorna la referencia del BlockUI para
     * una gestión posterior (cerrar el BlockUI, etc)
     *
     * @param component
     * @param options
     */
    show(component, options) {
        let thirdPartyBlockUIRef = this._overlay.create(this.getOverlayOptions(options));
        let ownBlockUIRef = this.createBlockUI(thirdPartyBlockUIRef, component, options);
        return ownBlockUIRef;
    }
    /**
     * Método que invoca un BlockUI de tipo [BlankComponent]{@link BlankComponent} y sirve principalmente para bloquear temporalmente
     * la pantalla mientras se está haciendo algún tipo de acción que requiere que el usuario no pueda navegar a otros sitios hasta
     * que ésta acabe. Se le puede pasar una configuración de tipo [NgwkBlockUIConfig]{@link NgwkBlockUIConfig} opcional
     *
     * @param options
     */
    block(options) {
        let overlayOptions = options ? options : { backdropClass: 'overlayBackdropBlockColor' };
        let thirdPartyBlockUIRef = this._overlay.create(this.getOverlayOptions(overlayOptions));
        let ownBlockUIRef = this.createBlockUI(thirdPartyBlockUIRef, BlankComponent, options);
        return ownBlockUIRef;
    }
    createBlockUI(thirdPartyBlockUIRef, content, options) {
        let ownBlockUIRef = new NgwkBlockUIRef(thirdPartyBlockUIRef);
        const componentPortal = new ComponentPortal(content, null, this.getInjector(options, ownBlockUIRef));
        thirdPartyBlockUIRef.attach(componentPortal);
        return ownBlockUIRef;
    }
    getOverlayOptions(options) {
        let overlayConfig = {};
        if (options) {
            if (options.panelClass) {
                overlayConfig.panelClass = options.panelClass;
            }
            if (options.hasBackdrop) {
                overlayConfig.hasBackdrop = options.hasBackdrop;
            }
            if (options.backdropClass) {
                overlayConfig.backdropClass = options.backdropClass;
            }
        }
        return Object.assign(Object.assign({}, this.DEFAULT_OVERLAYCONFIG), overlayConfig);
    }
    getInjector(options, blockUIRef) {
        const injectionTokens = new WeakMap();
        injectionTokens.set(BLOCKUI_PARAMS, {
            blockUIRef: blockUIRef,
            data: options ? options.data : null
        });
        return new PortalInjector(this._injector, injectionTokens);
    }
}
BlockUIService.ɵfac = function BlockUIService_Factory(t) { return new (t || BlockUIService)(ɵngcc0.ɵɵinject(ɵngcc6.Overlay), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
BlockUIService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: BlockUIService, factory: BlockUIService.ɵfac });
/** @nocollapse */
BlockUIService.ctorParameters = () => [
    { type: Overlay },
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BlockUIService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc6.Overlay }, { type: ɵngcc0.Injector }]; }, null); })();
/** Identificador para inyectar los parámetros en aquellos componentes custom que se quieran utilizar como parámetro en el
 * método 'show' del servicio
 */
const BLOCKUI_PARAMS = new InjectionToken("BLOCKUI_PARAMS");

/**
 * Generated bundle index. Do not edit.
 */

export { AlertModule, AlertService, BLOCKUI_PARAMS, BlockUIService, NgwkBlockUIRef, NgwkStickyHeaderDirective, NgwkToastRef, OverlayModule, StickyHeaderModule, ToastCardComponent, ToastErrorHandlerModule, ToastErrorHandlerService, ToastModule, ToastService, BlankModule as ɵa, BlankComponent as ɵb };

